<template>
    <ModalFormCard :submittedCallback="submittedCallback" action="/upload/folder" class="w-[400px]" headerCSS="!bg-white !stroke-black">
        <template #title>&nbsp;</template>

        <template #default="{ saving, errors }">
            <input name="_method" type="hidden" value="DELETE" />
            <input :value="options.folder" name="folder" type="hidden" />
            <input :value="options.belongs_id" name="belongs_id" type="hidden" />
            <input :value="options.belongs_type" name="belongs_type" type="hidden" />

            <p class="text-19 font-hero text-center">
                You are about to delete the "{{ options.folder.toLowerCase() }}" folder, {{ options.count }}
                {{ $help.pluralize('file', options.count) }} will be deleted.
            </p>

            <div class="grid grid-cols-4 pt-7 gap-4">
                <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2"> Delete folder </ButtonSaving>

                <button class="button-black-outline h-12 col-span-2" type="button" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    methods: {
        submittedCallback(res) {
            // console.log("submittedCallback");
            this.$event.$emit('upload-folder-deleted', res)
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },
}
</script>
